/**
 * Created by Ning Jiang on 2021-12-20.
 */

import {ReelStopPresentationController} from "../ReelStopPresentationController";
import {IReelStateEventData, ReelState} from "../../../core/reel/ReelState";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {KarenSoundManager} from "../../sound/KarenSoundManager";
import {Karen} from "../../Karen";
import {KarenReelView} from "../../reels/KarenReelView";
import {KarenLayers, Layers} from "../../view/KarenLayers";
import {SpinePlayer} from "../../../core/displayObject/SpinePlayer";
import {KarenSoundConfig} from "../../sound/KarenSoundConfig";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";

export class ReelNearWinController extends ReelStopPresentationController {

    private _defaultNearWinSpinStepDuration: number = 0.02;

    private _glow: SpinePlayer;
    private _nearWinReel: number = -1;

    constructor() {
        super('ReelNearWinController');
    }

    skip(): void {
        super.skip();
    }

    // TODO: in other games if there is inactive reel then near win in next reel, need to handle it.
    protected onReelStopped(data: IReelStateEventData): Promise<any> {
        const reel = Karen.reels[data.reelId];
        if (data.reelId === this._nearWinReel) {
            this._nearWinReel = -1;
            this.stopNearWin(data.reelId);
        }

        if (reel.nextStopReel && Karen.model.parsedGameData.nearWinReels[reel.nextStopReel]) {
            if (Karen.reels[reel.nextStopReel].reelView.nextSpinStepConfig) {
                Karen.reels[reel.nextStopReel].reelView.nextSpinStepConfig!.duration = this._defaultNearWinSpinStepDuration;
            } else {
                Karen.reels[reel.nextStopReel].reelView.nextSpinStepConfig = {
                    duration: this._defaultNearWinSpinStepDuration,
                };
            }
            this.playNearWin(reel.nextStopReel);
            return super.onReelStopped(data);
        }

        return super.onReelStopped(data);
    }

    private playNearWin(reelId: number): void {
        if (reelId === 5 && !this.isSkip && !Karen.apiPlugin.settings.get(APISetting.FAST_SPIN)) {
            Karen.reels[5].playSlowAttention();
            KarenSoundManager.playSoundEffect(KarenSoundConfig.WILD_NUDGE_ANTICIPATION);
        }
        this._nearWinReel = reelId;
        if (!this._glow) {
            this._glow = new SpinePlayer("anticipation");
            KarenLayers.getLayer(Layers.REEL_ATTENTION)!.addChild(this._glow);
        }
        if (Karen.model.parsedGameData.nearWinReels[reelId] && !Karen.model.parsedGameData.nearWinReels[reelId - 1]) {
            KarenSoundManager.playSoundEffect(KarenSoundConfig.SCATTER_ANTICIPATION);
        }
        const positionX = KarenReelView.REEL_AREAS[reelId].x;
        const positionY = KarenReelView.REEL_AREAS[reelId].y + KarenReelView.REEL_AREAS[reelId].height * 0.5;
        this._glow.position.set(positionX, positionY);
        let reelSymbols: number = Karen.model.gameData.evaluatedArea[reelId].length;
        this._glow.play({
            name: reelSymbols.toString(),
            skinType: reelId === 5 ? "wild" : "scatter",
            loop: true
        });
    }

    private stopNearWin(reelId?: number): void {
        if (this._glow) {
            this._glow.fadeOut(false);
        }
        if (reelId && Karen.model.parsedGameData.nearWinReels[reelId] && (!Karen.model.parsedGameData.nearWinReels[reelId + 1] || reelId == 4)) {
            if (reelId === 5) {
                KarenSoundManager.playSoundEffect(KarenSoundConfig.WILD_NUDGE_ANTICIPATION_END);
            }
            if (!this.scatterExistsOnNearWinReel(reelId)) {
                KarenSoundManager.playSoundEffect(KarenSoundConfig.SCATTER_ANTICIPATION_FAIL);
            }
            KarenSoundManager.fadeAndStopSound({
                name: KarenSoundConfig.SCATTER_ANTICIPATION,
                to: 0,
                duration: 100
            });
        }
    }

    private scatterExistsOnNearWinReel(reelId: number): boolean {
        let scatterExists: boolean = false;
        Karen.model.parsedGameData.evaluatedArea[reelId].forEach((symName: string) => {
            if (symName === "S") {
                scatterExists = true;
            }
        });
        return scatterExists;
    }
}
